<template>
<div>
  <Navbar title="用户协议" type="3" />
  <pre class="markdown-body container">
    本平台由青岛掌银信息技术有限公司及其关联实体(以下简称“本平台”)运营，本平台依照以下注册协议向您提供本注册协议涉及的相关服务。请您使用本平台服务前仔细阅读本注册协议。您只有完全同意所有注册协议，才能成为本平台的用户（以下简称为"用户"）并使用相应服务。您在注册为本平台用户过程中点击对应页面相应按钮表示您已仔细阅读并明确同意遵守本注册协议以及经参引而并入其中的所有条款、政策以及指南，并受该等规则的约束（合称"本注册协议"），且给予相关授权。本平台可能根据法律法规的要求或业务运营的需要，对本注册协议不时进行修改。除非另有规定，否则任何变更或修改将在修订内容于本平台发布之时立即生效，您对本平台的使用、继续使用将表明您接受此等变更或修改。如果您不同意本注册协议（包括本平台可能不定时对其或其中引述的其他规则所进行的任何修改）的全部规定，则请勿使用本平台提供的所有服务，或您可以主动取消本平台提供的服务。为了便于您了解适用于您使用本平台的条款和条件，您应不时地审阅本注册协议以及经参引而并入其中的其他规则。
    一、服务内容
    1.1本平台为您提供办理信用卡服务，包括但不限于为您直接提供银行信用卡链接或将您提交至本平台的个人信息反馈至银行信用卡中心，以此为您提供办理信用卡服务。本平台的具体服务内容由本平台根据实际情况提供并不时更新，包括但不限于信息、图片、文章、评论、链接等，本平台将定期或不定期根据用户的意愿以电子邮件、短信、电话或站内信等方式为用户提供活动信息，并向用户提供相应服务。本平台有权不时修改本协议及活动规则。
    1.2本平台服务仅供个人用户使用。除本平台书面同意，您或其他用户均不得将本平台上的任何信息用于商业目的。
    1.3您使用本平台服务时所需的相关的设备以及网络资源等（如个人电脑及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费）均由您自行负担。
    二、信息提供和隐私保护
    2.1您在访问、使用本平台或申请使用本平台服务时，必须提供本人真实的个人信息，且您应该根据实际变动情况及时更新个人信息。保护用户隐私是本平台的重点原则，本平台通过各种技术手段和强化内部管理等办法提供隐私保护服务功能，充分保护您的个人信息安全
    2.2本平台不负责审核您提供的个人信息的真实性、准确性或完整性，因信息不真实、不准确或不完整而引起的任何问题及其后果，由您自行承担，且您应保证本平台免受由此而产生的任何损害或责任。若本平台发现您提供的个人信息是虚假、不准确或不完整的，本平台有权自行决定终止向您提供服务。
    2.3您已明确授权，为提供服务、履行协议、解决争议、保障交易安全等目的，本平台对您提供的、本平台自行收集的及通过第三方收集的您的个人信息、您申请服务时的相关信息、您在使用服务时储存在本平台的非公开内容以及您的其他个人资料（以下简称“个人资料”）享有留存、整理加工、使用和披露的权利，具体方式包括但不限于：
    （1）出于为您提供服务的需要在本平台运营主体和关联机构、发卡机构留存、整理、加工、使用、公示、反馈您的个人资料；
    （2）由人工或自动程序对您的个人资料进行获取、评估、整理、存储；
    （3）使用您在第三方留存的手机号码、用户 ID 等资料用于注册、登录本平台；
    （4）使用您的个人资料以改进本网站的设计和推广；
    （5）使用您提供的联系方式与您联络并向您传递有关服务和管理方面的信息；
    （6）对您的个人资料进行分析整合并向为您提供服务的第三方提供为完成该项服务必要的信息。 当为您提供服务的第三方与您电话核实信息时，为保证为您服务的质量，你同意本平台对上述核实电话进行录音。
    （7）在您违反与本平台或本平台的其他用户签订的协议时，披露您的个人资料及违约事实，将
    您的违约信息写入黑名单并与必要的第三方共享数据，以供本平台及第三方审核、追索之用。
    （8）其他必要的使用及披露您个人资料的情形。您已明确同意本条款不因您终止使用本平台服务而失效。如因本平台行使本条款项下权利使您遭受损失，本平台对该等损失免责。
    2.4为更好地为您提供服务，您同意并授权本平台可与其合作的第三方进行联合研究，并可将通过本协议获得的您的信息投入到该等联合研究中。但本平台与其合作的第三方在开展上述联合研究前，应要求其合作的第三方对在联合研究中所获取的您的信息予以保密。
    2.5为更好地为您提供服务，您理解并同意在您注册成为本平台会员时，本平台有权调取并保存您的手机位置信息、手机设备信息、通讯录、通话记录以及短信（包括但不限于短信内容、短信时间、发送对象等）。另外，为使最终提供办卡服务的机构能够更准确地评估您的资信，本平台会将该等调取的信息发送给该机构，用于您本次办卡资信评估。
    2.6若您曾经已经登陆过本平台，且已经授权本平台完成了相应的信息获取事宜，当您再次登陆本平台，并选择相关产品时，您授权本平台自动将之前授权获取的您的信息推送给为您提供金融服务的机构。
  </pre>
</div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'userAgreement',
  data() {
    return {
    }
  },
  created() {
  }
}
</script>

<style scoped lang='scss'>
@import '~@/styles/_mixins.scss';
.container {
  word-wrap: break-word;
  white-space: pre-wrap;
  line-height: 1.5;
  @include safeArea(padding-bottom);
}
</style>
